export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info'
}
